import ImagePlaceholder from "@/components/base/ImagePlaceholder";

export default function EnrouleurGuidage() {
  const checks = [
    "Inspection visuelle de l'enrouleur et des ressorts",
    "Vérification du rembobinage automatique de la sangle",
    "Contrôle de l'alignement du guidage latéral",
    "Détection des points durs ou des blocages",
    "Réglage de la tension de l'enrouleur",
    "Lubrification des pièces mécaniques si nécessaire",
  ];

  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="relative rounded-xl overflow-hidden border border-[#E2E8F0]">
            <ImagePlaceholder src="https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20roller%20shutter%20strap%20winder%20and%20guidance%20mechanism%20inside%20a%20white%20shutter%20box%20with%20clean%20metal%20components%20and%20professional%20tools%20in%20a%20modern%20French%20home%20interior%20warm%20daylight%20professional%20repair%20photography&width=700&height=520&seq=sang-enroul&orientation=landscape" alt="Enrouleur et guidage de sangle de volet roulant" className="w-full h-[340px] md:h-[420px]" loading="lazy" />
          </div>

          <div>
            <h2 className="text-[#143A66] text-2xl md:text-3xl font-extrabold mb-5">
              Contrôle de l&apos;enrouleur et du guidage
            </h2>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-5">
              L&apos;enrouleur est le composant qui rembobine la sangle lorsque vous relâchez la traction. Si l&apos;enrouleur est faible, bloqué ou si son ressort est usé, la sangle ne rentrera pas correctement et restera pendante. Un enrouleur défectueux est souvent la cause cachée d&apos;une sangle qui semble « casser » trop vite. C&apos;est pourquoi nous inspectons systématiquement ce mécanisme à chaque intervention.
            </p>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-6">
              Le guidage de la sangle est tout aussi important. Un guidage mal aligné ou usé fait frotter la sangle contre les bords du coffre, ce qui l&apos;effiloche prématurément. Nos techniciens vérifient que les glissières latérales sont bien parallèles et que la sangle coulisse sans résistance. Si nécessaire, nous réglons le guidage ou remplaçons les butées usées pour garantir une manœuvre fluide.
            </p>

            <ul className="space-y-3 mb-8">
              {checks.map((check) => (
                <li key={check} className="flex items-center gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-[#00B3A4]/10 shrink-0">
                    <i className="ri-check-line text-[#00B3A4] text-sm"></i>
                  </span>
                  <span className="text-[#2F4A63] text-base">{check}</span>
                </li>
              ))}
            </ul>

            <a
              href="tel:0374473240"
              className="flex items-center gap-2 bg-[#00B3A4] text-white px-6 py-4 rounded-full font-semibold text-base hover:bg-[#00B3A4]/90 transition-colors whitespace-nowrap mx-auto"
            >
              <i className="ri-phone-line text-lg"></i>
              Appeler le 03 74 47 32 40
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}